import { DATE_PRESET_LABELS } from '@/state/legs/legsTypes';
import { EXCHANGES } from '@/lib/types/generalTypes';

export interface ClientStorage {
    selectedAccounts: MultiFetchAccount[];
    generalAdvancedFilters: any;
    accountAdvancedFilters: {
        [key: number]: any;
    };
    generalDateSelection: DateFilters;
    accountDateSelection: {
        [key: number]: DateFilters;
    };
    generalSymbolSelection: string[];
    accountSymbolSelection: {
        [key: number]: string[];
    };
    widgetsLayout: WidgetLayout[];
    isLiquidationSoundMuted?: boolean;
    walletDisplayMode?: WALLET_DISPLAY_MODE;
}

export enum WALLET_DISPLAY_MODE {
    NAMES = 'names',
    ADDRESSES = 'addresses',
}

export interface ClientStorageState {
    clientStorage: ClientStorage;
    currentAdvancedSelection: any;
    isLoading: boolean;
    innerSettingsChanged: string;
    selectedLeaderboardsTab: number;
    selectedTrendingWalletsTab: number;
    heatmapDisabledColumns: number[];
}

export interface DateFilters {
    startDate: string;
    endDate: string;
    label: DATE_PRESET_LABELS;
}

export interface WidgetInnerSettings {
    id: string;
    label?: string;
    isHidden?: boolean;
    position?: number;
}

export interface WidgetLayout {
    id: string;
    position: number;
    label: string;
    isHidden: boolean;
    innerSettings?: WidgetInnerSettings[];
}

export interface MultiFetchAccount {
    label: string;
    exchangeName: string;
    type: EXCHANGES;
    isUnlocked: boolean;
    keyError: any;
    accountId: number;
    isAnalyticsReady: boolean;
    isReportsReady: boolean;
}

export interface ClientStorageResponse {
    memberId: number;
    metadata: ClientStorage;
}

export enum WIDGETS {
    WALLET_COHORTS_BY_PERP_EQUITY = 'wallet_cohorts_by_perp_equity',
    WALLET_COHORTS_BY_ALL_TIME_PERP_PNL = 'wallet_cohorts_by_all_time_perp_pnl',
    TRENDING_WALLETS = 'trending_wallets_subtitle',
    POSITION_HEATMAP = 'position_heatmap',
    LEADERBOARDS = 'leaderboards',
    STATS = 'stats',
    FAVORITES = 'favorites',
}
